import { render, staticRenderFns } from "./DiagnosticBuilderChildren.vue?vue&type=template&id=3b86eab3&scoped=true&"
import script from "./DiagnosticBuilderChildren.vue?vue&type=script&lang=js&"
export * from "./DiagnosticBuilderChildren.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticBuilderChildren.vue?vue&type=style&index=0&id=3b86eab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86eab3",
  null
  
)

export default component.exports